import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from './Tooltip'

const ConditionalTooltip = (props) =>
  props.title ? <Tooltip {...props} /> : props.children

ConditionalTooltip.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
}

export default ConditionalTooltip
